import { FiArrowLeft, FiCheck } from 'react-icons/fi'
import React from 'react'
import {
	StyledPhotoEditorControlsContainer,
	StyledPhotoEditorButton,
} from 'components/Selfiebooth/PhotoEditor/styled'

interface ControlsProps {
	returnCamera: () => void;
	reversePhoto: () => void;
	validPhoto: () => void;
}

const Controls = ({ returnCamera, reversePhoto, validPhoto }: ControlsProps) => {
	return <>
		<StyledPhotoEditorControlsContainer>
			<StyledPhotoEditorButton onClick={returnCamera} $position="left">
				<FiArrowLeft />
			</StyledPhotoEditorButton>
			<StyledPhotoEditorButton onClick={reversePhoto} $position="center">
				<svg height="100px" width="100px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
					<g>
						<path fill="#FFFFFF" d="M32,68h36V32H32V68z M36,36h28v28H36V36z"></path>
						<path
							fill="#FFFFFF"
							d="M34,82h-6c-5.514,0-10-4.486-10-10v-9.172l4.586,4.586C22.976,67.805,23.488,68,24,68   s1.024-0.195,1.414-0.586c0.781-0.781,0.781-2.047,0-2.828l-8-8c-0.78-0.781-2.048-0.781-2.828,0l-8,8   c-0.781,0.781-0.781,2.047,0,2.828c0.78,0.781,2.048,0.781,2.828,0L14,62.828V72c0,7.72,6.28,14,14,14h6c1.104,0,2-0.896,2-2   S35.104,82,34,82z"
						></path>
						<path
							fill="#FFFFFF"
							d="M93.414,32.586c-0.781-0.781-2.047-0.781-2.828,0L86,37.172V28c0-7.72-6.28-14-14-14h-6   c-1.104,0-2,0.896-2,2s0.896,2,2,2h6c5.514,0,10,4.486,10,10v9.172l-4.586-4.586c-0.781-0.781-2.047-0.781-2.828,0   c-0.781,0.781-0.781,2.047,0,2.828l8,8C82.977,43.805,83.488,44,84,44s1.023-0.195,1.414-0.586l8-8   C94.195,34.633,94.195,33.367,93.414,32.586z"
						></path>
					</g>
				</svg>
			</StyledPhotoEditorButton>
			<StyledPhotoEditorButton onClick={validPhoto} $position="right">
				<FiCheck />
			</StyledPhotoEditorButton>
		</StyledPhotoEditorControlsContainer>
	</>
}

export default Controls;